export default {
	reviewDocuments: {
		account: '@:component.accounts.name',
		balance: 'Balance',
		status_options: 'Status options',
		record_count_determined: 'Number of records is being determined',
		document_review_protocol: 'Document review protocol',
		automatic_reminder: 'Automatic reminder',
		edit_documents: 'Edit documents',
		edit_reviewer: 'Edit reviewer',
		deactivate: 'Deactivate',
		activate: 'Activate',
		create_protocol: 'Create protocol',
		review_requires_reviewer:
			'You must define reviewers before document review can be activated.',
		confirm_disable_review: 'Are you sure you want to disable document review?',
		confirm_finish_review_without_checks:
			'You have not reviewed any transactions. Are you sure you want to finish the document review?',
		confirm_approve_with_disputes:
			'You are approving this document review, but you have disputed at least one transaction. Are you sure?',
		confirm_reject_without_disputes:
			'You are rejecting this document review, but you have not disputed any transaction. Are you sure?',
		confirm_review_action:
			'Are you sure you want to {action} the document review?',
		reopen_notify_reviewers_info:
			'When you reopen the document review, reviewers with pending status can be notified by email.',
		notify_pending_reviewers: 'Notify pending reviewers by email',
		confirm_no_changes_after_completion:
			'After completing the document review, no further changes are possible. Do you want to continue?',
		data_updated: 'Data has been updated',
		confirm_enable_review_message:
			'Do you really want to enable the document review? A notification will be sent to the defined reviewers. Subsequent changes are not possible during the review.',
		review_completed: 'Invoice review completed',
		invoice_review_completed:
			'The invoice review is complete. You can view the report here. No further changes are possible.',
		invoice_review_completed_2:
			'The invoice review has already been completed. No further changes are possible.',
		protocol_document_type_missing:
			'No document type has been defined for the {boldStart}report{boldEnd}. Please click {linkStart}here{linkEnd} to make the necessary change.',
		invoice_protocol: 'Invoice Review Protocol',
		performedOn: 'The invoice review was performed on',
		filter: {
			incomplete: 'incomplete',
			all: 'all',
		},
	},
}
